import React, { FC, useEffect, useState } from 'react'

import { DollarSign, Percent } from 'lucide-react'
import { KeyReturn } from 'phosphor-react'
import { useAuthBackoffice } from 'src/hooks/authBackoffice'
import { api } from 'src/services/api'
import toLocaleAmount from 'src/utils/toLocaleAmount'
import {
  Container,
  Content,
  ContentWrapper,
  Table,
  TableWrapper,
  Text,
} from './styles'
import './styles.css'

type TaxConfiguration = {
  id: string
  name: string
  tax: number
  taxType: 'VALUE' | 'PERCENTAGE'
}

export const TaxBackoffice: React.FC = () => {
  const [sidebarMobileIsActive, setSidebarMobileIsActive] = useState(false)

  const token2 = window.localStorage.getItem('@backoffice:token')

  const [data, setData] = useState<TaxConfiguration[]>([])

  const fetchTaxs = async () => {
    try {
      let url = `/backoffice/tax-configurations`
      const { data } = await api.get(url, {
        headers: { Authorization: 'Bearer ' + token2 },
      })

      setData(data)
    } catch (error) {}
  }

  const handleSidebarMobileToggle = () => {
    setSidebarMobileIsActive((state) => !state)
  }

  useEffect(() => {
    fetchTaxs()
  }, [])

  return (
    <Container>
      <Content>
        <ContentWrapper>
          <Text>
            <span>Configuração de tarifas</span>
          </Text>
          <Table>
            <TableWrapper>
              <table>
                <thead>
                  <tr>
                    <td>Tipo de tarifa</td>
                    <td className="text-center">Tarifa</td>
                    <td>Tarifa total</td>
                  </tr>
                </thead>
                <tbody>
                  {!data && <tr className="text-zinc-500">carregando</tr>}
                  {data.map((tax) => (
                    <TaxDetails key={tax.id} data={tax} />
                  ))}
                </tbody>
              </table>
            </TableWrapper>
          </Table>
        </ContentWrapper>
      </Content>
    </Container>
  )
}

const TaxDetails: FC<{ data: TaxConfiguration }> = ({ data }) => {
  const [tax, setTax] = useState<number>(data.tax)

  const token = window.localStorage.getItem('@backoffice:token')

  const [taxType, setTaxType] = useState<'VALUE' | 'PERCENTAGE'>(data.taxType)

  const [editingCheckin, setEditingCheckin] = useState<boolean>(false)
  const [editingCheckout, setEditingCheckout] = useState<boolean>(false)

  const _tax = toLocaleAmount(tax)

  const { user } = useAuthBackoffice()

  const role = user?.role || 'ADMIN'

  const onChangeTaxType = (event: any) => {
    event.stopPropagation()
    setTaxType((old) => (old === 'VALUE' ? 'PERCENTAGE' : 'VALUE'))
  }

  const onChangeTax = (event: any) => {
    const newValue = parseFloat(event.target.value)
    setTax(newValue)
  }

  const saveCheckin = () => {
    setEditingCheckin(false)
    setTax((newValue) => (Number.isNaN(newValue) ? 0 : newValue))
    updateTaxConfiguration()
  }

  const updateTaxConfiguration = async () => {
    try {
      let url = `/backoffice/tax-configurations`
      const response = await api.put(
        url,
        {
          id: data.id,
          tax: Number.isNaN(tax) ? 0 : tax,
          taxType: taxType,
        } as TaxConfiguration,
        {
          headers: { Authorization: 'Bearer ' + token },
        }
      )
    } catch (error) {
      console.log('erro ao atualizar taxa', error)
    }
  }

  const onKeyDown = (event: any) => {
    const pressedKey = event.key

    if (pressedKey === 'Enter') {
      saveCheckin()
    }
  }

  const totalString = `${
    taxType === 'VALUE' ? `R$ ${toLocaleAmount(tax)}` : `${tax}%`
  }`

  return (
    <tr>
      <td>{data.name}</td>
      {editingCheckin && role == 'MASTER' ? (
        <td
          onBlur={saveCheckin}
          onKeyDown={(e) => {
            if (e.key == 'Enter') saveCheckin()
          }}
          className="flex justify-between self-center items-center gap-1 text-center transition-all hover:bg-zinc-100 hover:border border-zinc-200 cursor-text"
        >
          <input
            onMouseDown={(e) => e.preventDefault()}
            onKeyDown={onKeyDown}
            autoFocus
            className="text-base max-w-[50px] text-zinc-700 bg-transparent h-full"
            type="number"
            value={tax}
            onChange={onChangeTax}
          />
          <div
            onMouseDown={(e) => e.preventDefault()}
            className="flex items-center gap-2"
          >
            <button
              onMouseDown={(e) => e.preventDefault()}
              onClick={onChangeTaxType}
              className={`p-2 transition-all flex items-center justify-center rounded-lg ${
                taxType === 'VALUE' ? 'bg-green-500' : 'bg-blue-500'
              }`}
            >
              {taxType == 'VALUE' ? (
                <DollarSign size={18} color="#fff" />
              ) : (
                <Percent size={18} color="#fff" />
              )}
            </button>
            <div className="flex flex-col items-center">
              <KeyReturn size={22} color="#bbb" />
              <span className="text-xs text-zinc-500">save</span>
            </div>
          </div>
        </td>
      ) : (
        <td
          style={{
            cursor: role === 'MASTER' ? 'text' : 'not-allowed',
          }}
          className="text-center transition-all hover:bg-zinc-100 hover:border border-zinc-200 cursor-text"
          onClick={() => {
            setEditingCheckin(true)
          }}
        >
          {taxType === 'VALUE' ? `R$ ${tax}` : `${tax}%`}
        </td>
      )}

      <td>{totalString}</td>
    </tr>
  )
}
